import { CYCLE_TASK_DEPENDENCY } from './constants';

const { BLOCKING, BLOCKED_BY, RELATES, CAN_APPROVE } = CYCLE_TASK_DEPENDENCY.DETAIL_FIELD;

/** Fields written by getdetails. Absent keys mean the next open must load them again. */
export const DEPENDENCY_DETAIL_KEYS = [BLOCKING, BLOCKED_BY, RELATES, CAN_APPROVE];

/** Neighbor lists on a getdetails task. canApprove is a flag, not a list. */
const DEPENDENCY_NEIGHBOR_KEYS = [BLOCKING, BLOCKED_BY, RELATES];

/**
 * True once v3 getTask has written neighbor lists onto the task.
 * An empty array counts as loaded. Missing keys mean the lists are still loading.
 * @param {object} task
 * @returns {boolean}
 */
export function taskHasDependencyDetail(task) {
  return DEPENDENCY_NEIGHBOR_KEYS.some((key) => Array.isArray(task?.[key]));
}

/**
 * @param {*} value
 * @returns {string}
 */
export function taskIdString(value) {
  if (value == null || value === '') return '';
  if (typeof value === 'object') {
    return taskIdString(value._id || value.$oid || value.id || value.taskId);
  }
  return String(value);
}

/**
 * Neighbor ids stored on a task from getdetails.
 * @param {object} task
 * @returns {string[]}
 */
export function dependencyNeighborIds(task) {
  const ids = [];
  DEPENDENCY_NEIGHBOR_KEYS.forEach((key) => {
    const rows = task?.[key];
    if (!Array.isArray(rows)) return;
    rows.forEach((row) => {
      const id = taskIdString(row);
      if (id) ids.push(id);
    });
  });
  return ids;
}
